import { CardPlacingOrder } from '@/entities/cart-page/CardPlacingOrder/ui/CardPlacingOrder'
import './ui/CardPlacingOrder.scss'
export default CardPlacingOrder
